import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Select } from '@techstyle/react-components-legacy';

import { mobile, oldMobileSafari } from '../../styles';

import { useSizeInputContext } from './SizeInput';

const StyledSelect = styled(Select)`
  ${props => props.theme.selectV2.defaultStyle};
  ${props => !!props.error && props.theme.selectV2.errorStyle};
  ${({ theme, isQuiz }) => isQuiz && theme.selectV2.quizStyle};
  margin-top: ${props => props.theme.spacing.tiny}px;
  min-width: 140px;
  ${mobile`
    ${({ fullWidth, theme }) =>
      fullWidth
        ? `width: 100%;`
        : `width: calc(50vw - ${theme.spacing.moderate}px);`}
  `}
  ${({ isQuiz, isShowingPlaceholderOnly }) =>
    isQuiz &&
    isShowingPlaceholderOnly &&
    `
      color: red;
      font-size: 32px;
      ${Select.Label} {
        top: 18px;
        span {
          font-size: 14px;
        }
      }
    `}
`;

const DropdownWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  letter-spacing: 1.75px;
  text-transform: uppercase;
  justify-content: center;

  ${oldMobileSafari`
    margin: 0px ${({ theme }) => theme.spacing.tiny}px;
  `};
`;

// Although this has a `placeholder` prop, it's the `label` prop that is used
// as the placeholder/prompt option of the select/dropdown.
const SizeSelection = ({
  className,
  name,
  placeholder,
  label,
  'data-autotag': dataAutoTag,
  fullWidth = true,
  isQuiz = false,
}) => {
  const { onChange, bandSizeList, cupSizeList, value, options } =
    useSizeInputContext();

  const [currentOptions, setCurrentOptions] = useState(
    name === 'bandSize' ? bandSizeList : cupSizeList || options
  );

  useEffect(() => {
    switch (name) {
      case 'bandSize':
        setCurrentOptions(bandSizeList);
        break;
      case 'cupSize':
        setCurrentOptions(cupSizeList);
        break;
      case 'braletteSize':
      case 'undieSize':
        setCurrentOptions(options);
        break;
      default:
        setCurrentOptions(cupSizeList);
        break;
    }
  }, [bandSizeList, cupSizeList, name, options]);

  const optionsValue = currentOptions.map(option => ({
    name: option,
    value: option,
  }));
  optionsValue.push({ name: 'Other', value: 'Other' });
  const currentValue =
    name === 'bandSize' || name === 'cupSize' ? value[name] : value;

  return (
    <DropdownWrapper className={className}>
      <StyledSelect
        data-autotag={dataAutoTag}
        label={label}
        fullWidth={fullWidth}
        isShowingPlaceholderOnly={!currentValue && placeholder?.length > 0}
        aria-label={name}
        name={name}
        placeholder={placeholder}
        value={currentValue || ''}
        options={optionsValue}
        onChange={onChange}
        isQuiz={isQuiz}
      />
    </DropdownWrapper>
  );
};

SizeSelection.propTypes = {
  'data-autotag': PropTypes.string,
  className: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  fullWidth: PropTypes.bool,
  isQuiz: PropTypes.bool,
};

SizeSelection.StyledSelect = StyledSelect;

export default SizeSelection;
